import { useState } from 'react';
import { Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useLocales } from '@/locales';

export default function Composer({ onSend, disabled, handoffActive }) {
  const { translate } = useLocales();
  const [value, setValue] = useState('');

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent.isComposing) {
      e.preventDefault();
      submit();
    }
  };

  const placeholder = handoffActive
    ? translate('chat_placeholder_handoff')
    : translate('chat_placeholder_ai');

  return (
    <div className="flex items-end gap-2 border-t border-gray-200 p-3 bg-white">
      <Textarea
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={1}
        className="resize-none max-h-32"
      />
      <Button
        type="button"
        size="icon"
        onClick={submit}
        disabled={disabled || !value.trim()}
        aria-label={translate('chat_send')}
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
}
